import { render, staticRenderFns } from "./FinalizacaoAssociarDespViagens.vue?vue&type=template&id=a2350a32"
import script from "./FinalizacaoAssociarDespViagens.vue?vue&type=script&lang=js"
export * from "./FinalizacaoAssociarDespViagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports